<template>
    <div class="timer-host">
        <!-- <div style="font-size: 10px !important; color: red;">{{ data.id }}</div> -->
        <div v-if="data.id !== 0" v-longpress="AddTimerMultiSelect" v-press="AddTimerSelect" class="timer" :class="[$mq, 'status-' + data.status, { active: data.status > 0, 'no-images': !showImages }]">
            <!-- <div v-if="data.same_product_status != null" :class="['rel-status', 'status-' + data.same_product_status]">
            </div> -->

            <div :class="['rel-status', data.data.color_relation ? 'status-' + data.data.color_relation : 'status-0']">
                {{ data.data.letter_relation }}
            </div>

            <header v-if="showImages">
                <img class="img" :src="product.image" />
            </header>
            <div class="bottom-section">
                <div class="name-wrap">
                    <span ref="name" class="text" :class="spanClass">
                        <span class="product-name">{{ product.name }}</span
                        ><span v-if="data.data.package" class="package-text"> {{ data.data.package }}</span>
                    </span>
                </div>
                <div class="time" :class="{ 'time-days': live && timeLeft.d != 0 }">
                    <template v-if="live && timeLeft.d == 0">
                        {{ timeLeft.h }}:{{ timeLeft.m }}<span class="seconds">:{{ timeLeft.s }}</span>
                    </template>
                    <template v-else-if="live && timeLeft.d != 0"> {{ timeLeft.d }} {{ $tc('timersproduct.day', timeLeft.d) }} </template>
                    <template v-else>00:00</template>
                </div>
            </div>
            <div v-if="data.isSelected" class="select-timer">
                <div class="corner-flag">
                    <span class="checkmark"></span>
                </div>
                <div class="border-white"></div>
            </div>
            <div v-if="data.isLoading" class="loading"></div>
            <span v-if="Number(data.data.quantity_avaibles) > 1" class="quantity-avaible">{{ Number(data.data.quantity_avaibles) ? Number(data.data.quantity_avaibles) : Number(data.data.quantity) }}</span>
        </div>
    </div>
</template>

<script>
import { TIMERPRODUCT_STATUS } from '@/constants'
import { soundService } from '@/services/soundService'

export default {
    props: {
        data: { type: Object },
        visibilityType: { type: Number },
        clickEnabledMulti: { type: Boolean },
        /**
         * BUILD-7551: si es false, oculta la imagen y densifica la tarjeta.
         * No altera long-press / selección / cálculo de tiempo.
         */
        showImages: { type: Boolean, default: true }
    },
    data() {
        return {
            now: moment(),
            active: true,
            spanClass: '',
            pressTimer: null,
            longPressDuration: 500,
            multiSelectedTimers: [],
            isBlocked: false, // Variable para bloquear clics
            blockDuration: 5000,
            isScrolling: false
        }
    },
    computed: {
        timeLeft: function () {
            var now = this.now
            if (this.visibilityType === 1) {
                var ref_date = this.data.data.date_timestamp
                if (this.data.status == TIMERPRODUCT_STATUS.PREPARATION) {
                    ref_date = this.data.data.prep_date_timestamp
                }

                var duration = moment.duration(moment(ref_date * 1000).diff(now))
                var diff = duration.asSeconds()
            } else {
                var ref_date = this.data.data.print_date_timestamp
                var duration = ref_date ? moment.duration(now.diff(moment(ref_date * 1000))) : 0
                var diff = ref_date ? Math.abs(duration.asSeconds()) : 0
            }

            // Cálculo común para ambos casos
            let diff_days = parseInt(diff / 86400)
            if (diff_days < 3) {
                diff_days = 0
            }
            diff = diff - diff_days * 86400
            let diff_hours = String(parseInt(diff / 3600)).padStart(2, '0')
            diff = diff - diff_hours * 3600
            let diff_minutes = String(parseInt(diff / 60)).padStart(2, '0')
            diff = diff - diff_minutes * 60
            let diff_seconds = String(parseInt(diff)).padStart(2, '0')

            return {
                d: diff_days,
                h: diff_hours,
                m: diff_minutes,
                s: diff_seconds
            }
        },

        live() {
            var ref_date = this.data.data.date_timestamp
            if (this.visibilityType === 1) {
                return this.data.status != TIMERPRODUCT_STATUS.EXPIRED
            }
            return true
        },

        product() {
            return this.$store.getters['timerproduct/getProducts'](this.data.reference_id)
        },

        soundEnabled() {
            return this.$store.getters['isSoundEnabled']
        },

        /**
         * Verifica si el timer está caducado o en 0
         */
        isExpiredOrZero() {
            if (this.data.status === TIMERPRODUCT_STATUS.EXPIRED) {
                return true
            }

            const nowTimestamp = moment().unix()

            if (this.visibilityType === 1) {
                var ref_date = this.data.data.date_timestamp
                if (this.data.status == TIMERPRODUCT_STATUS.PREPARATION) {
                    ref_date = this.data.data.prep_date_timestamp
                }

                if (ref_date && nowTimestamp >= ref_date) {
                    return true
                }

                if (ref_date) {
                    var duration = moment.duration(moment(ref_date * 1000).diff(this.now))
                    var diff = duration.asSeconds()
                    if (diff <= 0) {
                        return true
                    }
                }
            } else if (this.visibilityType === 2) {
                var print_date = this.data.data.print_date_timestamp
                if (print_date && nowTimestamp >= print_date) {
                    return true
                }
            }

            return false
        }
    },
    watch: {
        /**
         * Reproduce el sonido una sola vez cuando el timer pasa a estado caducado.
         * Solo se dispara en la transición false → true.
         */
        isExpiredOrZero(newValue, oldValue) {
            if (newValue && !oldValue && this.soundEnabled) {
                soundService.playNotificationSound('/sounds/timer-expired-alert.mp3', 1.0, `product-timer-${this.data.id}`)
            }
        },

        /**
         * Reproduce el sonido una sola vez cuando el status cambia a EXPIRED
         * (cubre los timers que llegan ya caducados desde el servidor).
         */
        'data.status'(newStatus, oldStatus) {
            if (newStatus === TIMERPRODUCT_STATUS.EXPIRED && oldStatus !== TIMERPRODUCT_STATUS.EXPIRED && this.soundEnabled) {
                soundService.playNotificationSound('/sounds/timer-expired-alert.mp3', 1.0, `product-timer-${this.data.id}`)
            }
        }
    },
    methods: {
        AddTimerSelect(e) {
            if (!this.clickEnabledMulti) {
                this.$emit('clickTimer', this.data.id)
            } else {
                this.$emit('addTimerSelected', this.data.id)
            }
        },
        AddTimerMultiSelect(e) {
            if (!this.isScrolling) {
                this.$emit('longPress', this.data.id)
                this.$emit('addTimerSelected', this.data.id)
            }
        },
        checkLines() {
            const span = this.$refs.name
            if (span) {
                const lineHeight = parseFloat(window.getComputedStyle(span).lineHeight)
                const spanHeight = span.offsetHeight

                if (spanHeight > lineHeight) {
                    this.spanClass = 'multi-line'
                } else {
                    this.spanClass = 'single-line'
                }
            } else {
                this.spanClass = 'multi-line'
            }
        },
        startPress() {
            if (this.pressTimer === null) {
                this.pressTimer = setTimeout(() => {
                    if (!this.isScrolling) {
                        this.$emit('longPress', this.data.id)
                        this.$emit('addTimerSelected', this.data.id)
                        this.isBlocked = true
                        setTimeout(() => {
                            this.isBlocked = false
                        }, this.blockDuration)
                    }
                }, this.longPressDuration)
            }
        },
        endPress() {
            if (this.isBlocked) {
                return false
            }

            if (this.pressTimer !== null && !this.clickEnabledMulti) {
                clearTimeout(this.pressTimer)
                this.pressTimer = null
                this.$emit('clickTimer', this.data.id)
            } else {
                this.$emit('addTimerSelected', this.data.id)
            }
        },
        cancelPress() {
            if (this.pressTimer !== null) {
                clearTimeout(this.pressTimer)
                this.pressTimer = null
            }
        },
        handleScroll() {
            this.isScrolling = true
            clearTimeout(this.scrollTimeout)
            this.scrollTimeout = setTimeout(() => {
                this.isScrolling = false
            }, 100)
        }
    },
    mounted() {
        this.checkLines()
        window.addEventListener('resize', this.checkLines)
        window.addEventListener('scroll', this.handleScroll, true)

        // Si el timer ya está caducado al montar, reproducir el sonido una sola vez.
        // El watcher isExpiredOrZero no detecta este caso porque no hay transición false→true.
        this.$nextTick(() => {
            if (this.isExpiredOrZero && this.soundEnabled) {
                soundService.playNotificationSound('/sounds/timer-expired-alert.mp3', 1.0, `product-timer-${this.data.id}`)
            }
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkLines)
        window.removeEventListener('scroll', this.handleScroll, true)
        if (this.updateInterval) {
            clearInterval(this.updateInterval)
        }
    },
    created() {
        var self = this
        self.updateInterval = setInterval(function () {
            self.now = moment()
        }, 1000)
    }
}
</script>

<style lang="scss" scoped>
.timer-host {
    display: flex;
    flex-direction: column;
    min-width: 0;
    align-self: stretch;
}

.timer {
    padding: 0;
    overflow: hidden;
    min-width: 0;
    box-sizing: border-box;
    // BUILD-7638: crece con el nombre; si la fila es más alta, llena la celda.
    width: 100%;
    flex: 1 0 auto;
    background-color: $color-error-500;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;

    &.portrait {
        height: auto;
    }

    /**
     * BUILD-7551: sin imagen.
     * Nombre arriba a la izquierda; sin hueco si es una línea.
     */
    &.no-images {
        flex: 1 0 auto;
        box-sizing: border-box;

        &.portrait {
            height: auto;
        }

        .bottom-section {
            flex: 1 1 auto !important;
            width: 100%;
            min-height: 0;
            box-sizing: border-box;
            padding-top: 28px;
            @include justify-content(flex-start);
            @include align-items(stretch);

            .name-wrap {
                display: block;
                width: 100%;
                max-width: 100%;
                box-sizing: border-box;
                flex: 0 0 auto;
                min-height: 0;
                max-height: 64px;
                overflow: hidden;
                margin-bottom: 4px;
            }

            .name-wrap .text {
                display: -webkit-box !important;
                /* autoprefixer: ignore next */
                -webkit-box-orient: vertical !important;
                -webkit-line-clamp: 3 !important;
                line-clamp: 3;
                overflow: hidden !important;
                width: 100% !important;
                max-width: 100% !important;
                box-sizing: border-box;
                max-height: 64px;
                text-align: left;
                margin-bottom: 0 !important;
                padding: 4px 4px 0 4px !important;
                word-break: normal;
                overflow-wrap: break-word;
                -webkit-hyphens: auto;
                hyphens: auto;
            }

            .time {
                flex: 0 0 auto;
                flex-shrink: 0;
                width: 100%;
                min-height: 30px;
                margin-top: auto !important;
            }
        }
    }

    .quantity-avaible {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 24px;
        height: 24px;
        color: $color-white;
        text-align: center;
        font-family: $text-bold;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
    }

    .loading {
        background-color: rgba(0, 0, 0, 0.3); // Oscurece el fondo con transparencia
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10; // Asegura que el loading esté sobre el contenido

        &::before {
            content: '';
            background-image: img('loader4_light.svg');
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 30px;
            width: 30px;
            height: 30px;
        }
    }

    .select-timer {
        background-color: rgba(238, 229, 229, 0.3);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        border: 4px solid $color-info-500;

        .border-white {
            width: 100%;
            height: 100%;
            border: 4px solid $color-white;
        }
    }

    .corner-flag {
        position: absolute;
        top: 0;
        right: 0;
        width: 0;
        height: 0;
        border-top: 50px solid $color-info-500;
        border-left: 50px solid transparent;
    }

    .checkmark {
        background-image: img('checked_timer.svg');
        background-size: contain;
        background-repeat: no-repeat;
        width: 24px;
        height: 24px;
        position: absolute;
        top: -45px;
        right: 0px;
        font-size: 24px;
    }

    &.status-0 {
        background-color: $color-error-500;
    }
    &.status-1 {
        background-color: $color-secondary-500;
    }
    &.status-2 {
        background-color: $color-success-500;
    }
    &.status-3 {
        background-color: $color-warning-500;
    }

    .rel-status {
        width: 24px;
        height: 24px;
        border: 1px solid $color-white;
        background-color: $color-primary-300;
        position: absolute;
        top: 5px;
        left: 5px;
        z-index: 5;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $color-white;
        font-size: 14px;
        line-height: normal;
        font-weight: 700;
        font-style: normal;

        &.status-1 {
            background-color: $color-primary-300;
        }
        &.status-2 {
            background-color: $color-primary-500;
        }
        &.status-3 {
            background-color: $color-primary-800;
        }
        &.status-4 {
            background-color: $color-secondary-500;
        }
        &.status-5 {
            background-color: $color-secondary-800;
        }
        &.status-6 {
            background-color: $color-neutral-600;
        }
        &.status-7 {
            background-color: $color-warning-800;
        }
        &.status-8 {
            background-color: $color-success-800;
        }
        &.status-9 {
            background-color: $color-info-500;
        }
        &.status-10 {
            background-color: $color-error-800;
        }
    }

    header {
        // La imagen queda anclada arriba (no crece), agrupada con el nombre.
        flex: 0 0 auto;
        width: 100%;
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        overflow: hidden;
        padding: 5px;

        .img {
            display: block;
            width: 35px;
            height: 35px;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    }

    .bottom-section {
        @include timer-bottom-section;
        flex: 1 1 auto;
        min-height: 0;
        @include justify-content(flex-start);

        .name-wrap {
            display: block;
            width: 100%;
            min-width: 0;
            min-height: 0;
            box-sizing: border-box;
            flex: 0 0 auto;
            max-height: 64px;
            overflow: hidden;
            margin-bottom: 4px;
        }

        .text {
            // Arriba a la izquierda. Máximo 3 líneas; el resto se corta con ….
            display: -webkit-box;
            /* autoprefixer: ignore next */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            max-height: 64px;
            text-align: left;
            word-break: normal;
            overflow-wrap: break-word;
            -webkit-hyphens: auto;
            hyphens: auto;
            margin-bottom: 0;
            overflow: hidden;
        }

        .time {
            margin-top: auto;
            flex-shrink: 0;
            width: 100%;
            max-width: 100%;
            min-height: 30px;
            box-sizing: border-box;
            white-space: nowrap;
            overflow: hidden;

            &.time-days {
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
